export default __webpack_public_path__ + "static/media/demo3.628b021f.gif";